import React from 'react';
import { motion } from 'framer-motion';
import { TrendingDown, TrendingUp } from 'lucide-react';
import QawaemStatsCard from '../../../products/saudi/components/QawaemStatsCard';

const VARIANTS = ['forest', 'copper', 'forest', 'copper'];

function HeroKpiCard({ item, index }) {
  const shell = index % 2 === 0 ? 'glass-stat-green' : 'glass-stat-bronze';
  const Icon = item.icon;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.08 }}
      className="lg:col-span-2 lg:row-span-2"
    >
      <div
        className={`${shell} h-full min-h-[220px] p-8 flex flex-col justify-between transition-transform duration-300 hover:scale-[1.005]`}
      >
        <div className="relative z-[1] flex items-start justify-between gap-4">
          <div className="min-w-0 flex-1 text-start">
            <p className="glass-stat-label text-sm font-medium">{item.label || '—'}</p>
            <p className="glass-stat-value text-4xl font-bold mt-3 tabular-nums leading-tight">{item.value}</p>
            {item.sub ? <p className="text-white/55 text-sm mt-2">{item.sub}</p> : null}
            {item.trend ? (
              <div
                className={`flex items-center gap-1 mt-3 text-sm ${
                  item.trend === 'up' ? 'text-emerald-300' : 'text-rose-300'
                }`}
              >
                {item.trend === 'up' ? <TrendingUp className="h-4 w-4" /> : <TrendingDown className="h-4 w-4" />}
                <span>{item.trendValue || item.trendLabel}</span>
              </div>
            ) : null}
          </div>
          {Icon ? (
            <div className="glass-stat-icon shrink-0 p-4 rounded-2xl">
              <Icon className="h-8 w-8" aria-hidden />
            </div>
          ) : null}
        </div>
      </div>
    </motion.div>
  );
}

export default function KPIGrid({ hero, items = [] }) {
  const cards = items.slice(0, 4);

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 auto-rows-fr">
      {hero ? <HeroKpiCard item={hero} index={0} /> : null}
      {cards.map((item, i) => (
        <QawaemStatsCard
          key={item.key || item.label}
          label={item.label}
          value={item.value}
          icon={item.icon}
          variant={item.variant || VARIANTS[i % VARIANTS.length]}
          delay={0.08 + (hero ? i + 1 : i) * 0.06}
          className={item.wide ? 'lg:col-span-2' : ''}
        />
      ))}
    </div>
  );
}
